import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import Hardscape from "../../components/hardscape/Hardscape";

function HardscapePage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Hardscape | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"Hardscape"} t={t} />
      <Hardscape />
    </>
  );
}

export default HardscapePage;
